import {
  Select as MantineSelect,
  type SelectProps as MantineSelectProps,
} from '@mantine/core';
import { useMergedRef } from '@mantine/hooks';
import { useIsMdBreakpoint } from 'hooks';
import { forwardRef, useRef, useState } from 'react';
import { ChevronDownIcon } from '../../../../icons';
import { ClearableInputRightSection } from '../ClearableInputRightSection';
import { useErrorTranslation } from '../hooks';
import { SelectModal } from './SelectModal';

export type SelectProps = MantineSelectProps;

export const Select = forwardRef<any, SelectProps>((props, ref) => {
  const { readOnly, value, clearable, onBlur, onFocus, error } = props;
  const errorMessage = useErrorTranslation(!!error, error);
  const isMobile = !useIsMdBreakpoint();
  const [SelectModalOpened, setSelectModalOpened] = useState(false);

  const [isFocussed, setIsFocused] = useState(false);

  const inputRef = useRef<HTMLInputElement>(null);

  const mergedRef = useMergedRef(inputRef, ref);

  const isClearable = clearable && isFocussed && value !== null && value !== '';

  return (
    <>
      <SelectModal
        label={props.label}
        searchable
        clearable={clearable}
        data={props.data}
        opened={SelectModalOpened}
        value={value}
        onChange={(newValue: any) => {
          if (props.onChange) {
            props.onChange(newValue);
          }
          setSelectModalOpened(false);
        }}
        onSearchChange={props.onSearchChange}
        searchValue={props.searchValue}
        onClose={() => setSelectModalOpened(false)}
      />
      <MantineSelect
        ref={mergedRef}
        readOnly={isMobile || readOnly}
        rightSection={
          isClearable ? (
            <ClearableInputRightSection
              isClearable={isClearable}
              inputRef={inputRef}
              rightIcon={<ChevronDownIcon className="rotate" />}
            />
          ) : undefined
        }
        {...props}
        error={errorMessage}
        onClick={() => {
          if (isMobile) {
            setSelectModalOpened(true);
          }
        }}
        onBlur={e => {
          setIsFocused(false);

          if (onBlur) {
            onBlur(e);
          }
        }}
        onFocus={e => {
          setIsFocused(true);

          if (onFocus) {
            onFocus(e);
          }
        }}
      />
    </>
  );
});

export default Select;
